import axios from 'axios'

// JWT в localStorage: при XSS токены доступны скрипту. Долгосрочно — httpOnly cookie для refresh
// (нужны изменения на back: Set-Cookie, CORS credentials). См. docs/SECURITY_FRONTEND.md

const baseURL = process.env.VUE_APP_API_URL || '/api'
const normalizedBaseURL = baseURL.endsWith('/') ? baseURL : `${baseURL}/`

const api = axios.create({
  baseURL: normalizedBaseURL,
})

let refreshPromise = null

function isRefreshRequest(config) {
  const url = (config?.url || '').replace(/^\//, '')
  return url === 'token/refresh/' || url.endsWith('token/refresh/')
}

function clearAuthAndRedirectLogin() {
  localStorage.removeItem('access')
  localStorage.removeItem('refresh')
  if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/login')) {
    window.location = '/login'
  }
}

api.interceptors.request.use(cfg => {
  if (cfg.url && cfg.url.startsWith('/')) {
    cfg.url = cfg.url.slice(1)
  }
  const token = localStorage.getItem('access')
  if (token) cfg.headers.Authorization = `Bearer ${token}`
  return cfg
})

api.interceptors.response.use(
  r => r,
  async err => {
    const status = err.response?.status
    const original = err.config
    if (status !== 401 || !original || original._retry || isRefreshRequest(original)) {
      if (status === 401 && !isRefreshRequest(original)) {
        clearAuthAndRedirectLogin()
      }
      return Promise.reject(err)
    }

    const refresh = localStorage.getItem('refresh')
    if (!refresh) {
      clearAuthAndRedirectLogin()
      return Promise.reject(err)
    }

    original._retry = true

    if (!refreshPromise) {
      refreshPromise = api
        .post('token/refresh/', { refresh })
        .then(({ data }) => {
          const access = data?.access
          if (!access) {
            throw new Error('refresh_missing_access')
          }
          localStorage.setItem('access', access)
          if (data.refresh) {
            localStorage.setItem('refresh', data.refresh)
          }
          return access
        })
        .finally(() => {
          refreshPromise = null
        })
    }

    try {
      const access = await refreshPromise
      original.headers = original.headers || {}
      original.headers.Authorization = `Bearer ${access}`
      return api.request(original)
    } catch (_) {
      clearAuthAndRedirectLogin()
      return Promise.reject(err)
    }
  }
)

export default api
